export default {
  functionKey: "EQUIV",
  title: "EQUIV",
  group: "Organisation",
  target: [],
  arguments: [],
  targetRequired: true,
  description: "Comparer les arguments entre eux et émettre un statut de comparaison dans un autre champ",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    if (args.length < 2) return { displayCode: "", safeCode: "" };
    const code = `${destination} = ${args[0]} === ${args.slice(1).join(' && ' + args[0] + ' === ')}`;
    return { displayCode: code, safeCode: code };
  }
}
